var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-layout',{staticStyle:{"position":"absolute","top":"0","left":"0"},style:({
      'z-index': _vm.zIndex,
      background: _vm.backgroundColor,
      'pointer-events': _vm.pointerEvents,
      width: _vm.width,
      height: _vm.height,
    })},[_c('v-layout',{style:({
        'padding-top': _vm.paddingTop,
      }),attrs:{"justify-center":""}},[_c('v-progress-circular',{staticClass:"mt-5",class:_vm.indicatorClass,attrs:{"indeterminate":"","size":_vm.size}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FullpageLoadingIndicator.vue?vue&type=template&id=e12c272e&
// module id = 1988
// module chunks = 5